import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1b45c7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content_wrapper contract_wrapper" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "back_button_img",
  src: "/assets/img/arrow-left.svg"
}, null, -1))
const _hoisted_4 = { class: "contract_page_wrapper" }
const _hoisted_5 = { class: "contract_data" }
const _hoisted_6 = { class: "w-100 pt-1 contract_title" }
const _hoisted_7 = { class: "contract_recurring_payments_agrees" }
const _hoisted_8 = {
  key: 0,
  class: "m-0"
}
const _hoisted_9 = {
  key: 1,
  class: "m-0"
}
const _hoisted_10 = {
  key: 0,
  class: "contract_status_description w-100"
}
const _hoisted_11 = { class: "mt-3 contract_data_block" }
const _hoisted_12 = { class: "block_label" }
const _hoisted_13 = { class: "block_info" }
const _hoisted_14 = { class: "mt-3 contract_data_block" }
const _hoisted_15 = { class: "block_label" }
const _hoisted_16 = { class: "block_info" }
const _hoisted_17 = { class: "mt-3 contract_data_block" }
const _hoisted_18 = { class: "block_label" }
const _hoisted_19 = { class: "block_info" }
const _hoisted_20 = { class: "mt-3 contract_data_block" }
const _hoisted_21 = { class: "block_label" }
const _hoisted_22 = { class: "block_info" }
const _hoisted_23 = { class: "mt-3 contract_data_block" }
const _hoisted_24 = { class: "block_label" }
const _hoisted_25 = { class: "block_info" }
const _hoisted_26 = { class: "mt-3 contract_data_block" }
const _hoisted_27 = { class: "block_label" }
const _hoisted_28 = { class: "block_info" }
const _hoisted_29 = { class: "mt-3 contract_data_block" }
const _hoisted_30 = { class: "block_label" }
const _hoisted_31 = { class: "block_info" }
const _hoisted_32 = {
  key: 1,
  class: "mt-3 contract_data_block"
}
const _hoisted_33 = { class: "block_label" }
const _hoisted_34 = { class: "block_info" }
const _hoisted_35 = { class: "contract_data mt-2" }
const _hoisted_36 = { class: "contract_payment_block mt-3" }
const _hoisted_37 = { class: "block_label" }
const _hoisted_38 = {
  key: 0,
  class: "flex"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot dot_contract_active mr-2" }, null, -1))
const _hoisted_40 = { class: "block_info" }
const _hoisted_41 = { class: "payment_date" }
const _hoisted_42 = {
  key: 1,
  class: "flex"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "block_info" }, "-", -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { class: "contract_payment_block mt-3" }
const _hoisted_46 = { class: "block_label" }
const _hoisted_47 = ["title"]
const _hoisted_48 = {
  key: 0,
  class: "flex"
}
const _hoisted_49 = { class: "block_info" }
const _hoisted_50 = { class: "payment_date" }
const _hoisted_51 = {
  key: 0,
  class: "next_payment_service_type"
}
const _hoisted_52 = {
  key: 1,
  class: "flex"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "block_info" }, "-", -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = {
  key: 2,
  class: "contract_next_payment_following"
}
const _hoisted_56 = { class: "contract_data mt-6" }
const _hoisted_57 = { class: "service_title" }
const _hoisted_58 = { class: "my-0" }
const _hoisted_59 = { class: "service_add_button_text" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: "/assets/img/plus.svg"
}, null, -1))
const _hoisted_61 = { class: "service_wrapper mt-3" }
const _hoisted_62 = { class: "service" }
const _hoisted_63 = { class: "service_title_wrapper" }
const _hoisted_64 = { class: "service_title_data service_name" }
const _hoisted_65 = {
  key: 0,
  class: "flex service_title_data not_payed"
}
const _hoisted_66 = {
  key: 1,
  class: "flex"
}
const _hoisted_67 = { class: "mt-0 mb-0 service_title_data" }
const _hoisted_68 = {
  key: 2,
  class: "flex"
}
const _hoisted_69 = { class: "mt-0 mb-0 service_title_data" }
const _hoisted_70 = {
  key: 3,
  class: "flex service_title_data"
}
const _hoisted_71 = ["onClick"]
const _hoisted_72 = ["onClick"]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "service_delete_button_img",
  src: "/assets/img/delete.svg"
}, null, -1))
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = { class: "service_body_wrapper" }
const _hoisted_76 = { class: "mt-3 service_body" }
const _hoisted_77 = { class: "block_label" }
const _hoisted_78 = {
  key: 0,
  class: "block_info"
}
const _hoisted_79 = {
  key: 1,
  class: "block_info"
}
const _hoisted_80 = { class: "mt-3 service_body" }
const _hoisted_81 = { class: "block_label" }
const _hoisted_82 = {
  key: 0,
  class: "flex"
}
const _hoisted_83 = { class: "block_info" }
const _hoisted_84 = { class: "payment_date" }
const _hoisted_85 = {
  key: 1,
  class: "flex"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "block_info" }, "-", -1))
const _hoisted_87 = [
  _hoisted_86
]
const _hoisted_88 = { class: "contract_data mt-6" }
const _hoisted_89 = { class: "additional_freezing_days_title" }
const _hoisted_90 = { class: "my-0 additional_freezing_days_h" }
const _hoisted_91 = { class: "service_add_button_text" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: "/assets/img/plus.svg"
}, null, -1))
const _hoisted_93 = { class: "contract_data mt-6" }
const _hoisted_94 = { class: "w-100" }
const _hoisted_95 = { class: "my-0" }
const _hoisted_96 = { class: "contract_data mt-6" }
const _hoisted_97 = { class: "w-100" }
const _hoisted_98 = { class: "my-0" }

export function render(_ctx, _cache) {
  const _component_v_last_viewed_clients_tabs = _resolveComponent("v-last-viewed-clients-tabs")
  const _component_v_alert = _resolveComponent("v-alert")
  const _component_addService = _resolveComponent("addService")
  const _component_addAdditionalFreezingDays = _resolveComponent("addAdditionalFreezingDays")
  const _component_retryToPayService = _resolveComponent("retryToPayService")
  const _component_paymentExplanationModal = _resolveComponent("paymentExplanationModal")
  const _component_v_client_tabs_menu = _resolveComponent("v-client-tabs-menu")
  const _component_paymentSchedule = _resolveComponent("paymentSchedule")
  const _component_v_datatable = _resolveComponent("v-datatable")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_last_viewed_clients_tabs, {
      currentClientId: _ctx.contract?.clientId
    }, null, 8, ["currentClientId"]),
    _createVNode(_component_v_alert, {
      modelValue: _ctx.showAlert,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.showAlert) = $event)),
      title: 'contract.view.service_delete',
      text: 'contract.view.are_you_sure',
      successButtonText: _ctx.$t('contract.view.confirm'),
      cancelButtonText: _ctx.$t('contract.view.cancel'),
      onSuccess: _ctx.deleteService,
      onCancel: _cache[1] || (_cache[1] = $event => (_ctx.showAlert = false))
    }, null, 8, ["modelValue", "title", "text", "successButtonText", "cancelButtonText", "onSuccess"]),
    (_ctx.showAddService)
      ? (_openBlock(), _createBlock(_component_addService, {
          key: 0,
          availableServices: _ctx.contract.availableServices,
          currencySign: _ctx.contract.currencySign,
          contractId: _ctx.contract.id,
          hasClientPaymentMean: _ctx.contract.clientPaymentMean,
          onClose: _cache[2] || (_cache[2] = $event => (_ctx.showAddService = false)),
          onUpdate: _ctx.updateContract
        }, null, 8, ["availableServices", "currencySign", "contractId", "hasClientPaymentMean", "onUpdate"]))
      : _createCommentVNode("", true),
    (_ctx.showAdditionalFreezingDays)
      ? (_openBlock(), _createBlock(_component_addAdditionalFreezingDays, {
          key: 1,
          availableServices: _ctx.contract.availableAdditionalFreezingDays,
          currencySign: _ctx.contract.currencySign,
          contractId: _ctx.contract.id,
          hasClientPaymentMean: _ctx.contract.clientPaymentMean,
          onClose: _cache[3] || (_cache[3] = $event => (_ctx.showAdditionalFreezingDays = false)),
          onUpdate: _ctx.updateContract
        }, null, 8, ["availableServices", "currencySign", "contractId", "hasClientPaymentMean", "onUpdate"]))
      : _createCommentVNode("", true),
    (_ctx.showRetryToPayService)
      ? (_openBlock(), _createBlock(_component_retryToPayService, {
          key: 2,
          serviceContractId: _ctx.serviceRetryToPayId,
          additionalFreezingDayId: _ctx.additionalFreezingDayRetryToPayId,
          contractId: _ctx.contract.id,
          hasClientPaymentMean: _ctx.contract.clientPaymentMean,
          onClose: _cache[4] || (_cache[4] = $event => (_ctx.showRetryToPayService = false)),
          onUpdate: _ctx.updateContract
        }, null, 8, ["serviceContractId", "additionalFreezingDayId", "contractId", "hasClientPaymentMean", "onUpdate"]))
      : _createCommentVNode("", true),
    (_ctx.showNextPaymentExplanation)
      ? (_openBlock(), _createBlock(_component_paymentExplanationModal, {
          key: 3,
          orderId: _ctx.contract?.nextPaymentOrderId,
          onClose: _cache[5] || (_cache[5] = $event => (_ctx.showNextPaymentExplanation = false))
        }, null, 8, ["orderId"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_client_tabs_menu, {
        clientId: _ctx.contract?.clientId,
        activeTab: "contracts"
      }, null, 8, ["clientId"]),
      _createElementVNode("button", {
        onClick: _cache[6] || (_cache[6] = $event => (_ctx.$router.push(`/client/${_ctx.contract?.clientId}/contracts`))),
        class: "button button_back",
        disabled: !_ctx.contract?.clientId
      }, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('contract.view.contracts')), 1)
      ], 8, _hoisted_2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("p", { class: "agreement" }, _toDisplayString(_ctx.contract?.agreement) + ", " + _toDisplayString(_ctx.contract?.clubName) + " (" + _toDisplayString(_ctx.contract?.contract) + ")", 513), [
              [_vShow, _ctx.isLoaded]
            ]),
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass('contract_status status_text_' + _ctx.getContractStatus(_ctx.contract?.status))
            }, _toDisplayString(_ctx.$t('contract_status.' + _ctx.getContractStatus(_ctx.contract?.status ?? 1))), 3), [
              [_vShow, _ctx.isLoaded]
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            (_ctx.contract?.hasUserAgreedWithRecurringPayments)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$t('contract.view.client_agreed_with_recurring_payments')), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('contract.view.client_disagreed_with_recurring_payments')), 1))
          ], 512), [
            [_vShow, _ctx.contract?.hasUserAgreedWithRecurringPayments != null]
          ]),
          (_ctx.contractStatusDescription)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.contractStatusDescription), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('contract.view.start_date')), 1),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.getFormatedDate(_ctx.contract?.startDate, "DD.MM.yyyy") || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('contract.view.end_date')), 1),
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.getFormatedDate(_ctx.contract?.endDate, "DD.MM.yyyy") || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('contract.view.price')), 1),
            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.getFormatedAmount(_ctx.contract?.price)) + " " + _toDisplayString(_ctx.contract?.currencySign), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('contract.view.referralcode')), 1),
            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.contract?.referralPromocode), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('contract.view.freeze')), 1),
            _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t('contract.view.available_days')) + ": " + _toDisplayString(_ctx.contract?.availableFreezingDaysNumber), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t('contract.view.freeze_price')), 1),
            _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.getFormatedAmount(_ctx.contract?.freezePrice)) + " " + _toDisplayString(_ctx.contract?.currencySign), 1)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('contract.view.guest_visits')), 1),
            _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t('contract.view.available_visits')) + ": " + _toDisplayString(_ctx.contract?.availableGuestVisit), 1)
          ]),
          (_ctx.contract?.pin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$t('contract.view.pin')), 1),
                _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.contract?.pin), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.$t('contract.view.previous_payment')), 1),
            (_ctx.contract?.previousPaymentDueDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("p", _hoisted_40, [
                    _createTextVNode(_toDisplayString(_ctx.getFormatedAmount(_ctx.contract?.previousPaymentTotal)) + " " + _toDisplayString(_ctx.contract?.currencySign) + " ", 1),
                    _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.getFormatedDate(_ctx.contract?.previousPaymentDueDate, "DD.MM.yyyy") || '-'), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_44)),
            _withDirectives(_createElementVNode("div", { class: "contract_previous_payment_queue" }, "(" + _toDisplayString(_ctx.$t('contract.view.paid_contract_previos_paid')) + " " + _toDisplayString(_ctx.getFormatedDate(_ctx.contract?.previousPaymentProcessedDate, "DD.MM.yyyy") || '-') + ")", 513), [
              [_vShow, _ctx.isShowPreviousPaymentProcessedDate]
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("p", _hoisted_46, [
              _createTextVNode(_toDisplayString(_ctx.$t('contract.view.next_payment')), 1),
              (_ctx.contract?.nextPaymentOrderId)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "info_icon_button",
                    title: _ctx.$t('order.order_details'),
                    onClick: _cache[7] || (_cache[7] = $event => (_ctx.showNextPaymentExplanation = true))
                  }, "ⓘ", 8, _hoisted_47))
                : _createCommentVNode("", true)
            ]),
            (_ctx.contract?.nextPaymentDueDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.contract?.nextPaymentDueDate != _ctx.contract?.nextPaymentQueueDate ? 'dot dot_contract_indebt mr-2' : 'dot dot_contract_active mr-2')
                  }, null, 2),
                  _createElementVNode("p", _hoisted_49, [
                    _createTextVNode(_toDisplayString(_ctx.getFormatedAmount(_ctx.contract?.nextPaymentTotal)) + " " + _toDisplayString(_ctx.contract?.currencySign) + " ", 1),
                    _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.getFormatedDate(_ctx.contract?.nextPaymentQueueDate, "DD.MM.yyyy") || '-'), 1),
                    (_ctx.contract?.nextPaymentServiceType)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_51, "· " + _toDisplayString(_ctx.$t(_ctx.contract?.nextPaymentServiceType)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_54)),
            _withDirectives(_createElementVNode("div", { class: "contract_previous_payment_queue" }, "(" + _toDisplayString(_ctx.$t('contract.view.in_debt_since')) + " " + _toDisplayString(_ctx.getFormatedDate(_ctx.contract?.nextPaymentDueDate, "DD.MM.yyyy") || '-') + ")", 513), [
              [_vShow, _ctx.contract?.nextPaymentDueDate != _ctx.contract?.nextPaymentQueueDate]
            ]),
            (_ctx.contract?.followingPaymentOrderId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(_ctx.$t('contract.view.next_payment_following')) + ": " + _toDisplayString(_ctx.getFormatedAmount(_ctx.contract?.followingPaymentTotal)) + " " + _toDisplayString(_ctx.contract?.currencySign) + " " + _toDisplayString(_ctx.getFormatedDate(_ctx.contract?.followingPaymentQueueDate, "DD.MM.yyyy")), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.isLoaded && _ctx.isShowPaymentSchedule)
          ? (_openBlock(), _createBlock(_component_paymentSchedule, {
              key: 0,
              contract: _ctx.contract
            }, null, 8, ["contract"]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("h3", _hoisted_58, _toDisplayString(_ctx.$t('contract.view.services')), 1),
            (_ctx.isLoaded && _ctx.hasAddServicePermission && _ctx.contract?.status == 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "service_add_button",
                  onClick: _cache[8] || (_cache[8] = $event => (_ctx.showAddService = true))
                }, [
                  _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t('clients.view.add')), 1),
                  _hoisted_60
                ]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contract?.services, (service) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.hasPayServicePermission && !service.hasPaid ? 'service_name_wrapper_with_pay_button':'service_name_wrapper')
                  }, [
                    _createElementVNode("p", _hoisted_64, _toDisplayString(service.name), 1),
                    (!service.hasPaid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.$t('contract.view.not_paid')), 1))
                      : (service.hasPaid && service.status == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                            _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.$t('contract.view.activating')), 1)
                          ]))
                        : (!service.isMandatory && service.clientTerminationDate && service.status != 6 && service.status != 5)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                              _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.$t('contract.view.service_terminated', [_ctx.getFormatedDate(service.clientTerminationDate, "DD.MM.yyyy")])), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                              _createElementVNode("div", {
                                class: _normalizeClass('dot dot_service_contract_' + _ctx.getServiceContractStatus(service.status))
                              }, null, 2),
                              _createTextVNode(_toDisplayString(_ctx.$t('service_contract_status.' + _ctx.getServiceContractStatus(service.status))), 1)
                            ]))
                  ], 2),
                  (_ctx.hasPayServicePermission && !service.hasPaid)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "pay_button",
                        onClick: $event => {_ctx.serviceRetryToPayId = service.serviceContractId; _ctx.additionalFreezingDayRetryToPayId = 0; _ctx.showRetryToPayService = true}
                      }, _toDisplayString(_ctx.$t('contract.view.pay')), 9, _hoisted_71))
                    : _createCommentVNode("", true),
                  (_ctx.hasDeleteServicePermission && !service.isMandatory && !service.clientTerminationDate && service.status != 6 && service.status != 5)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "service_delete_button",
                        onClick: $event => {_ctx.showAlert = true; _ctx.serviceToDeleteId = service.serviceContractId}
                      }, _hoisted_74, 8, _hoisted_72))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("p", _hoisted_77, _toDisplayString(_ctx.$t('contract.view.period_of_validity')), 1),
                    (service.endDate)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_78, _toDisplayString(_ctx.$t('contract.view.from_till', [_ctx.getFormatedDate(service.startDate, "DD.MM.yyyy"), _ctx.getFormatedDate(service.endDate, "DD.MM.yyyy")])), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_79, _toDisplayString(_ctx.$t('contract.view.from', [_ctx.getFormatedDate(service.startDate, "DD.MM.yyyy")])), 1))
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("p", _hoisted_81, _toDisplayString(_ctx.$t('contract.view.next_payment')), 1),
                    (service.nextPaymentDate && !service.clientTerminationDate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                          _createElementVNode("p", _hoisted_83, [
                            _createTextVNode(_toDisplayString(_ctx.getFormatedAmount(service.nextPaymentAmount)) + " " + _toDisplayString(_ctx.contract?.currencySign) + " ", 1),
                            _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.getFormatedDate(service.nextPaymentDate, "DD.MM.yyyy") || '-'), 1)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_85, _hoisted_87))
                  ])
                ]),
                (!service.hasPaid)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "pay_button_mobile",
                      onClick: _cache[9] || (_cache[9] = (...args) => (_ctx.payService && _ctx.payService(...args)))
                    }, _toDisplayString(_ctx.$t('contract.view.pay')), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 256)),
          _withDirectives(_createElementVNode("div", { class: "empty_table mt-3" }, _toDisplayString(_ctx.$t('contract.view.no_services')), 513), [
            [_vShow, _ctx.contract?.services.length == 0]
          ])
        ], 512), [
          [_vShow, _ctx.contract?.services.length > 0 || _ctx.hasAddServicePermission]
        ]),
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("h3", _hoisted_90, _toDisplayString(_ctx.$t('contract.view.additional_freezing_days')), 1),
            (_ctx.isLoaded && _ctx.hasAddServicePermission && _ctx.contract?.status == 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "service_add_button",
                  onClick: _cache[10] || (_cache[10] = $event => (_ctx.showAdditionalFreezingDays = true))
                }, [
                  _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.$t('clients.view.add')), 1),
                  _hoisted_92
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_v_datatable, {
            class: "mt-3",
            columTemplates: _ctx.additionalFreezingDaysColumTemplates,
            data: _ctx.additionalFreezingDaysTableData,
            onClickOnButton: _ctx.clickOnTableButton,
            emptyTableClass: 'empty_table',
            isLoading: !_ctx.isLoaded
          }, null, 8, ["columTemplates", "data", "onClickOnButton", "isLoading"])
        ]),
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("h3", _hoisted_95, _toDisplayString(_ctx.$t('contract.view.freeze_history')), 1)
          ]),
          _createVNode(_component_v_datatable, {
            class: "mt-3",
            columTemplates: _ctx.freeeHistoryColumTemplates,
            data: _ctx.freeeHistoryTableData,
            emptyTableClass: 'empty_table',
            isLoading: !_ctx.isLoaded
          }, null, 8, ["columTemplates", "data", "isLoading"])
        ]),
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("h3", _hoisted_98, _toDisplayString(_ctx.$t('contract.view.discounts')), 1)
          ]),
          _createVNode(_component_v_datatable, {
            class: "mt-3",
            columTemplates: _ctx.discountColumTemplates,
            data: _ctx.discountTableData,
            emptyTableClass: 'empty_table',
            isLoading: !_ctx.isLoaded
          }, null, 8, ["columTemplates", "data", "isLoading"]),
          _withDirectives(_createElementVNode("p", { class: "discount_footnote" }, "* - " + _toDisplayString(_ctx.$t('contract.view.estimated_date_of_application')), 513), [
            [_vShow, _ctx.discountTableData.length > 0]
          ])
        ])
      ])
    ])
  ], 64))
}